module.exports = __webpack_public_path__ + "style/img/智能感知安防小区.aee4a2d7.jpg";